export default [
	{
		id: '202001',
		year: '2020',
		title: 'Coffee And Kitty',
		description: `decentralized, pseudonymous, open and transparent, are known as features of
	blockchain.<br />
	In the centralized system, only the bank or government can see what you are
	doing.<br />
	But in the decentralized system, since blockchains are transparent, every
	action in the ledger can be easily checked and viewed.<br />
	The most crucial elements are addresses. everything we do in the blockchain
	is related to address, a 27-34 digit code consisting of letters and
	numbers.<br /><br />
	There are three groups of people have the addresses:<br />
	Miner, Intermediaries, for example, the virtual currency exchange or
	contract, and the general user.<br />
	In some cases like the general user who wants to use cryptocurrency as a
	payment method, how many of them should we treat as our personal data?<br />
	These bunch of addresses is not only exiting in blockchain but also spread
	on the internet.<br />
	<br />
	This work begins with a cup of coffee and a crypto kitty. To buy a cup of
	coffee and a crypto kitty, how many addressed have been connected, and how
	many addresses will be connected in the future?  How many of those addresses
	will be found on the internet and how many of them are the real user, or
	even be found the real personal data somewhere on the internet? How much
	information can we get if we only google it?<br />
	I visualize it, google it, checking the website.<br />
	Every activity, transaction, contract we found from this work are already
	spread, stored, and couldn't be erased from the internet.<br />`,
		photos: ['202001-1.png', '202001-2.png', '202001-3.png'],
		video: 'https://player.vimeo.com/video/394302836',
		tools: 'Python, TouchDesigner, Etherereum'
	},
	{
		id: '201901',
		year: '2019',
		title: 'Digital Footprint',
		description: `
		The right to control our own data has become a serious topic today.<br /><br />
		In the generation of information explosion, not only the information we
		receive, but also our personal data is being uploaded to the internet
		unconsciously. In the future, the one who has the most information will be
		the overlord.
		<br /><br />
		In the work "digital footprint", Hsiao Li-Chi visualises the internet as a
		small space. Everything that has happened in this space will be played out
		and then a hash code will be printed as proof of the event’s existence. It
		will play only once. The audience has to watch out to memorise it, if they
		miss it, it will become just a digital footprint.
		<br /><br />
		Key, keyhole, footprint.
		<br />
		Everything was determined once you decide to join it.`,
		photos: ['201901-1.jpg'],
		video: 'https://player.vimeo.com/video/368924183',
		tools: 'Python, TouchDesigner, React'
	},
	{
		id: '201801',
		year: '2018',
		title: 'Time Capsule Project',
		description:
			"<a class='link' style='font-weight: bold; color: #ffffff; font-size: 12pt;' href='https://timecapsuleproject.herokuapp.com' target='_blank'>Website</a><br>People always try to preserve their memory. In the past, they use a mural, painting. After the Industrial Revolution, they use photography, the sound record. Through the improvement of the Technology, the way people preserve memory changed too.<br>Time Capsule is also a way to preserve memory. People write what they want to say to their future- self in a paper, put the paper into a bottle and buried it. After 10 years, they go back to dig it out to see what 10-year-ago’s themselves want to tell themselves in the future. Time changes everything, also change a person. Sometimes we want to go back to the past and talks to ourselves. What did we change through the time flies? Sometime we can't remember what is the most important thing for us 10 years ago. And sometimes we deserve to have a conversation with ourselves in the past.<br>",
		photos: ['201801-1.png', '201801-1.png'],
		tools: 'Python, Tnesorflow, Docker, Vue.js, Kubernetes'
	},
	{
		id: '201802',
		year: '2018',
		title: 'My Tiny News',
		description:
			"<a class='link' style='font-weight: bold; color: #ffffff; font-size: 12pt;' href='https://siaolichi.github.io/MyTinyNews/' target='_blank'>Website</a><br>What’s the image of AI in our mind? Maybe cool, be dangerous, be marvelous, but it can also be friendly, and cute. Like Doraemon.<br>Alan Turing said that he design a machine like a child, not an adult. He also argued that it might be good if his child computer acted randomly, at least some of that time.<br> Take it easy, and make everything possible. that’s what my project want to achieve. <br>This newspaper is written by my little AI journalist. Like most of three year old children, it read lot’s of fairytale and children’s books. Such like Grimm, one thousand and one night, also fairytale from japan, brazil. It will keep on reading lot’s fairytale. It is going to discover the world through its tiny digital eyes, and share with people what it saw in the newspaper and website.<br><br>reference:<br>In the machine learning part, I use the \"Story teller\" by Ryan Kiros<br>https://github.com/ryankiros/neural-storyteller<br>",
		photos: ['201802-1.jpg', '201802-2.jpg', '201802-3.jpg', '201802-4.jpg'],
		video: 'https://player.vimeo.com/video/256007429',
		tools: 'Javascript, Tensorflow, Python, Raspberry Pi'
	},
	{
		id: '201803',
		year: '2018',
		title: 'Women in Another Words',
		description:
			'Collaborate with Taiwan consmetic brand "VesCir". <br>A word to describe your best condition. <br>I put this conception in our audio-visual project. People can test their skin condition and create threir own video in the exibition, after taht, they can download throw app or recieve by E-mail',
		photos: [
			'201803-1.jpg',
			'201803-2.jpg',
			'201803-3.jpg',
			'201803-4.jpg',
			'201803-5.jpg',
			'201803-6.jpg',
			'201803-7.jpg'
		],
		tools: 'Openframeworks, Python'
	},
	{
		id: '201804',
		year: '2018',
		title: 'Diatomee',
		description:
			'<b>description updating...</b><br/><br/>AR Installation.<br/><br/><b>Cooperated with Hsiangfu Chen</b>',
		photos: [
			'201804-1.jpg',
			'201804-2.jpg',
			'201804-3.jpg',
			'201804-4.jpg',
			'201804-5.jpg',
			'201804-6.jpg',
			'201804-7.jpg'
		],
		tools: 'Processing, AR'
	},
	{
		id: '201701',
		year: '2017',
		title: 'Mountains in Rain',
		description:
			'Shan shui painting, refers to a style of traditional Chinese painting that involves or depicts scenery or natural landscapes, using a brush and ink rather than more conventional paints. In Chinese, “Shan” is mountain and “Shui” is water, but the two elements together signify a landscape. When Chinese painters work on shan shui painting, they do not try to present an image of what they have seen in the nature, but what they have thought about nature.<br><br>Chinese Shan shui painting was brought to Taiwan with a plenty of immigrants, just like other immigrant culture, after thee generations, new generations began to reflect on the relationship between original culture and themselves.<br><br>Through this project, I began to think what is the nature of Taiwan in my mind. Taiwan is a island which full of mountain and rain. In my hometown, the best time to see the mountain after raining days. In this time, there are no impurities but some steam in the air, the shape of mountains are clear but soft. It feel like a landscape with stretched mountains which made by rain.<br><br>In oder to reproduce the image, I made a installation to create mountains by rain. In the upside of five acrylic plates are five tube. The whole installation connect to the weather of Taiwan’s five longitudinal mountain ranges. Each tube represent a mountain from north to south. If the mountain is raining, the tube will begin to supply ink, when ink drop down into the gap between five acrylic plate, it create the shape of mountains.<br>',
		photos: ['201701-1.jpg', '201701-2.jpg', '201701-3.jpg'],
		video: 'https://player.vimeo.com/video/237695191',
		tools: 'Arduino Yun, Processing.org'
	},
	{
		id: '201601',
		year: 2016,
		title: 'Portrait',
		description:
			"A portrait contains the feelings and words of the artist, the spirit of the characters in the painting, and the viewer's emotional projection from the painting.<br>everyone will give it different feedback when they saw a work, so does portrait.<br>Especially when I see a certain person in a portrait looks like someone, then the painting I am looking at is not just the painting itself, but also the connection between the painting and myself.<br>But for me, most of time, especially portrait from Europe, I feel nothing. I have none connection of it.<br>I don’t know why and it bothered for a while. So I decide to create a connection between me and the portrait.<br>In this work, the characters of the portrait will gradually imitate the facial features and expressions of the viewer. In these changes, the viewer's facial expression will also be affected, then the portrait will change again. In this forth to back watching and changing, a slow and silent dialogue is formed.",
		photos: ['201601-1.jpg', '201601-2.jpg', '201601-3.jpg'],
		video: 'https://player.vimeo.com/video/197504445',
		tools: 'Version 1: Openframeworks, Version 2: Javascript'
	}
];
